import React, { useEffect } from "react";
import Layout from "../components/Layout";
import { useSelector, useDispatch } from "react-redux";
import { listGallery } from "../redux/actions/galleryAction";
import { listNews } from "../redux/actions/newsAction";
import { listEvents } from "../redux/actions/eventsAction";

const HomeScreen = () => {
  const dispatch = useDispatch();
  const listGalleryState = useSelector((state) => state.listGallery);
  const { gallerys } = listGalleryState;
  const listNewsState = useSelector((state) => state.listNews);
  const { news } = listNewsState;
  const listEventsState = useSelector((state) => state.listEvents);
  const { events } = listEventsState;

  useEffect(() => {
    dispatch(listGallery());
    dispatch(listNews());
    dispatch(listEvents());
  }, []);
  return (
    <Layout>
      {/* <!-- start page title --> */}
      <div class="page-title-box">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h6 class="page-title">Dashboard</h6>
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item active">Welcome to Dashboard</li>
            </ol>
          </div>
        </div>
      </div>
      {/* <!-- end page title --> */}
      {/* row */}
      <div className="row">
        <div className="col-xl-3 col-md-6">
          <div className="card mini-stat bg-primary text-white">
            <div className="card-body">
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src="assets/images/services-icon/01.png" alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase text-white-50">
                  Events
                </h5>
                <h4 className="fw-medium font-size-24">
                  {events && events.length}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6">
          <div className="card mini-stat bg-primary text-white">
            <div className="card-body">
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src="assets/images/services-icon/02.png" alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase text-white-50">
                  News
                </h5>
                <h4 className="fw-medium font-size-24">
                  {news && news.length}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6">
          <div className="card mini-stat bg-primary text-white">
            <div className="card-body">
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src="assets/images/services-icon/03.png" alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase text-white-50">
                  Gallery
                </h5>
                <h4 className="fw-medium font-size-24">
                  {gallerys && gallerys.length}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* row end */}
    </Layout>
  );
};

export default HomeScreen;
